var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4, _react_refresh_temp_5;
_react_refresh_temp_4 = $RefreshSig$();
_react_refresh_temp_5 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, } from 'react';
import { C } from '#integrations';
import { Tooltip, useTooltip } from '../../../Tooltip';
import { useHandleFocus } from '../../hooks';
import styles from './Td.module.css';
// Td without tooltip
const TdBase = ({ children, className, 'data-testid': testId, id, isFocusable, onClick, onFocus, onKeyDown, }) => {
    _react_refresh_temp_4();
    const ref = useHandleFocus(isFocusable);
    return (_jsx("td", { className: C(styles.Container, className), "data-testid": `table-cell-${testId}`, id: id, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, ref: ref, children: children }));
};
_react_refresh_temp_1 = TdBase;
$RefreshReg$(_react_refresh_temp_1, "TdBase");
_react_refresh_temp_4(TdBase, "cs6VrqWjsrrLE7Fq6h+HdpcVL2w=", false, () => [useHandleFocus]);
// Td with tooltip
const TdWithTooltip = ({ children, className, 'data-testid': testId, id, isFocusable, onClick, onFocus, onKeyDown, tooltip, }) => {
    _react_refresh_temp_5();
    const { isTooltipActive, tooltipProps, triggerProps: { onFocus: onTooltipFocus, ref: tooltipTriggerRef, ...triggerProps }, } = useTooltip({
        strategy: 'fixed',
        ...(tooltip.placement && { placement: tooltip.placement }),
    });
    const ref = useHandleFocus(isFocusable);
    const mergedRef = useCallback((node) => {
        ref.current = node;
        tooltipTriggerRef(node);
    }, [tooltipTriggerRef, ref]);
    return (_jsx(_Fragment, { children: _jsxs("td", { ...triggerProps, className: C(styles.Container, className), "data-testid": `table-cell-${testId}`, id: id, onClick: onClick, onFocus: (event) => {
                onFocus(event);
                onTooltipFocus?.(event);
            }, onKeyDown: onKeyDown, ref: mergedRef, children: [children, isTooltipActive && (_jsx(Tooltip, { contents: tooltip.content, tooltipProps: tooltipProps }))] }) }));
};
_react_refresh_temp_2 = TdWithTooltip;
$RefreshReg$(_react_refresh_temp_2, "TdWithTooltip");
_react_refresh_temp_5(TdWithTooltip, "3HDrfsGDEpQ4ldYdNwupMT15SGE=", false, () => [useTooltip, useHandleFocus]);
export const Td = (props) => {
    return props.tooltip ? (_jsx(TdWithTooltip, { ...props, tooltip: props.tooltip })) : (_jsx(TdBase, { ...props }));
};
_react_refresh_temp_3 = Td;
$RefreshReg$(_react_refresh_temp_3, "Td");
